module.exports = __webpack_public_path__ + "static/media/Missions_Interlink_logo.dde65c1f.png";